<template lang="pug">
  #header
    .title.d-flex.justify-content-center.align-center
      img(src="/assets/img/microsite/title-viral.png")
    .header-text.d-flex.mt-5
      p En los últimos dos meses, la pandemia de Coronavirus ha transformado el mundo como lo conocemos.  Un virus que hace cuatro meses no existía, ha contagiado a casi dos millones de personas, matado a más de cien mil y representa el reto más grande para la humanidad desde la segunda guerra mundial, según el Secretario General de las Naciones Unidas. El epicentro de la pandemia es ahora nuestro continente, que no tiene ni de cerca la infraestructura de varios de los países europeos más golpeados por la enfermedad.  El virus ha venido a revelar muchas de nuestras desigualdades y carencias, pero aún nos queda mucho por entender. 
      p.mt-2.mb-0.italic ¿Dónde está parado México ante la pandemia? 
      p
        span.italic En Data Cívica creamos 
        span.boldest VIRAL 
        span.italic para averiguarlo 
      a.down.d-flex.mt-2(href="#section1")
        i.fas.fa-arrow-down

</template>

<script>
export default {
  name: "Header"
};
</script>

<style lang="scss">
#header {
  min-height: 80vh;
  padding-bottom: 10rem;
  display: flex;
  flex-direction: column;
  justify-content: space-evenly;
  .title {
    background-image: url("/assets/img/microsite/PATTERN_ok.png");
    background-size: cover;
    background-position: center;
    justify-content: center;
    min-height: 400px;
    img {
      width: 75vw;
      height: auto;
      max-width: 500px;
      max-height: 300px;
      padding: 4rem 0 0 0;
      display: block;
      margin: auto;
    }
  }
  .down {
    width: 40px;
    height: 40px;
    border: solid 3px #ff6561;
    border-radius: 50%;
    justify-content: center;
    align-items: center;
    color: #fff;
  }
  .header-text {
    flex-direction: column;
    align-items: center;
    margin: 1rem auto 0 auto;
    width: 60vw;
    justify-content: center;
    p {
      color: #fff;
      text-align: center;
      line-height: 2;
      font-size: 1rem;
    }
  }
}
// Small devices
@media (max-width: 500px) {
  #header {
    .title {
      img {
        padding: 8vh 0;
        max-width: 260px;
        max-height: 240px;
      }
    }
    .header-text {
      width: 90vw;
      margin: 0 auto;
      p {
        font-size: 0.8rem;
      }
    }
  }
}
</style>
